import React, { Component } from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import { BannerConsumer } from "../../context/banner-context";

import NotesForm from "./NotesForm";
import NoteList from "./NoteList";

export class Notes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSuccess: false,
      isFail: false,
      notes: [],
    };

    this.getNotesList = this.getNotesList.bind(this);
  }

  getNotesList() {
    const url = `${BACKEND_CONFIG.apiUrl}clients/${this.props.clientId}/policies/${this.props.policyId}/notes`;

    axios
      .get(url)
      .then((result) =>
        this.setState({ notes: result.data.Response.Response.Notes })
      )
      .catch();
  }

  componentDidMount() {
    this.getNotesList();
  }

  render() {
    let closeNotes = this.props.closeNotes;

    return (
      <div>
        <BannerConsumer>
          {(context) => {
            this.showBanner = context.showBanner;
          }}
        </BannerConsumer>
        <NotesForm
          onSuccess={() => {
            this.getNotesList();
            this.showBanner(
              "Quote note has been sent to the underwriter",
              null,
              true
            );
          }}
          onFail={() => {
            closeNotes();
            this.showBanner(
              `Your note could not be attached to Quote #${this.props.quoteNumber}, ${this.props.lob}. Please try again.`
            );
            this.setState({ isFail: true });
          }}
          policyId={this.props.policyId}
          clientId={this.props.clientId}
        />
        <NoteList notes={this.state.notes} />
      </div>
    );
  }
}
